import React, { lazy } from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function ContactInfo() {
  return <div className="space-y-12" data-id="element-652">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-653">
        <div className="animate-scroll-fade-up bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-654">
          <MapPin className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-655" />
          <h3 className="text-white font-bold text-lg mb-2" data-id="element-656">Visit Us</h3>
          <p className="text-gray-400 text-sm" data-id="element-657">
            1304 E. Empire Suite 2.
            <br data-id="element-658" />
            Bloomington, Illinois 61701
            <br data-id="element-659" />
            <span className="text-xs text-gray-500" data-id="element-660">
              (Inside the Regions Bank Complex at the intersection of Empire &
              Towanda)
            </span>
          </p>
        </div>
        <div className="animate-scroll-fade-up bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" style={{
        animationDelay: '0.1s'
      }} data-id="element-661">
          <Phone className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-662" />
          <h3 className="text-white font-bold text-lg mb-2" data-id="element-663">Call Us</h3>
          <p className="text-gray-400" data-id="element-664">(309) 242-2440</p>
        </div>
        <div className="animate-scroll-fade-up bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" style={{
        animationDelay: '0.2s'
      }} data-id="element-665">
          <Mail className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-666" />
          <h3 className="text-white font-bold text-lg mb-2" data-id="element-667">Email Us</h3>
          <p className="text-gray-400" data-id="element-668">walkerskicks@gmail.com</p>
        </div>
        <div className="animate-scroll-fade-up bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" style={{
        animationDelay: '0.3s'
      }} data-id="element-669">
          <Clock className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-670" />
          <h3 className="text-white font-bold text-lg mb-2" data-id="element-671">Hours</h3>
          <p className="text-gray-400 text-sm" data-id="element-672">
            Mon-Thu: 5am - 9pm
            <br data-id="element-673" />
            Fri: 5am - 7pm
            <br data-id="element-674" />
            Sat: 9am - 2pm
            <br data-id="element-675" />
            Sun: 8am - 12pm
          </p>
        </div>
      </div>

      <div className="w-full h-64 bg-gray-800 rounded-2xl overflow-hidden" data-id="element-676">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.457098203393!2d-88.97141592336078!3d40.48896885123858!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880b6fd6c70b6475%3A0x91a7795d82d1363e!2sWalker&#39;s%20Martial%20Arts!5e1!3m2!1sen!2sus!4v1767637136317!5m2!1sen!2sus" width="100%" height="100%" style={{
        border: 0
      }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Walker's Martial Arts Location" data-id="element-677" />
      </div>
    </div>;
}